import { authPut } from "@api";
import { UserInvite } from "@types";

export const updateUserInvite = (
  userInvite: UserInvite
): Promise<UserInvite> => {
  const url = `/api/agent/user_invites/${userInvite.id}`;
  return authPut<{ user_invite: UserInvite }, { user_invite: UserInvite }>(
    url,
    {
      user_invite: userInvite,
    }
  ).then((result) => result.user_invite);
};
